import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_LV.json';
import recipes from './COOKING_RECIPES_LV.json';
import videos from './COOKING_VIDEOS_LV.json';

export const COOKING_DATA_LV: ServiceData = {
  articles,
  recipes,
  videos,
};
